import type { AuthStoreOrg } from '@client/stores/AuthStore/types';

export function shouldPrefetchHomeDashboardCounts({
    hasValidToken,
    isTrainingManagerOnly,
    hydratedOrg,
    routeOrgId,
    navigationCause,
}: {
    hasValidToken: boolean;
    isTrainingManagerOnly: boolean;
    hydratedOrg: AuthStoreOrg | undefined;
    routeOrgId: bigint;
    navigationCause: 'preload' | 'enter' | 'stay';
}): boolean {
    return hasValidToken && !isTrainingManagerOnly && navigationCause !== 'stay' && hydratedOrg?.id === routeOrgId;
}
